/* eslint-disable react/require-default-props */
import { FC } from "react";
import Chart from "react-apexcharts";
import { useAppSelector } from "../../Redux/app/hooks";
import { ChartTitle } from "../Generals/RouteStyles";
import Loader from "../Reusables/Tables/Loader";

interface BarChartProps {
  series: any;
  options: object;
  title?: string;
}

const BarChart: FC<BarChartProps> = ({ series, options, title }) => {
  const { filterMode } = useAppSelector((state) => state.form);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#fff",
        padding: "15px 5px",
        borderRadius: "5px",
      }}
    >
      {title && <ChartTitle>{title}</ChartTitle>}
      {filterMode ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {series && (
            <Chart
              type="bar"
              width="100%"
              height="100%"
              series={series}
              options={options}
            />
          )}
        </>
      )}
    </div>
  );
};

export default BarChart;
